// extracted by mini-css-extract-plugin
export default {"arrangements":"Arrangements_arrangements__NeWlp","arrangements__content":"Arrangements_arrangements__content__SO2Q2"};